import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_home_decor_garden: FaireCategoryEntity = {
  token: "cat_home-decor-garden",
  type: "category",
  name: "Garden & outdoor",
  level: 2,
  parentToken: "cat_home-decor",
  href: "/category/home-decor/garden-outdoor",
  childCategoryTokens: [
    "cat_garden-all",
    "cat_garden-bbq",
    "cat_garden-tools",
    "cat_garden-outdoor-decor",
    "cat_garden-entertaining",
    "cat_garden-furniture",
    "cat_garden-pots-plants",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
